import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefineinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Refine/16px",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M1,4 L15,4",
				id: "Path-11",
				stroke: "#000000",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle",
				stroke: "#000000",
				fill: "#000000",
				x: 3.5,
				y: 1.5,
				width: 5,
				height: 5,
				rx: 2.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1,12 L15,12",
				id: "Path-10",
				stroke: "#171717",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle",
				stroke: "#000000",
				fill: "#000000",
				x: 7.5,
				y: 9.5,
				width: 5,
				height: 5,
				rx: 2.5
			})
		]
	})
});
export default SvgRefineinline;
